<template>
  <div class="detail-template w-full h-full" @click="$emit('cellclick', { dataItem, field: null, event: $event })">
    <slot :props="{ scope: scopeItem, selected: isSelected, inEdit: isInEdit, inEditDetail: isInEditDetail, expanded: isExpanded }"
      :listeners="{ save: updateDataItem, cancel: resetScopeItem, select: setSelected, edit: setInEdit, 'edit-detail': setInEditDetail, expand: setExpanded }">
      <span> {{JSON.stringify(dataItem)}} </span>
    </slot>
  </div>
</template>
<script>
import getChanges from '@/services/functions/getChanges'
import getNestedValue from '@/services/functions/getNestedValue'
import setNestedValue from '@/services/functions/setNestedValue'
import { cloneDeep, keys, merge } from 'lodash'


export default {
  name: 'detail-template',
  props: {
    tableId: [String, Number],
    dataItem: Object,
    dataIndex: Number,
    selectedField: {
      type: String,
      default: 'selected'
    },
    expandField: {
      type: String,
      default: 'expanded'
    },
    editField: {
      type: String,
      default: 'inEdit'
    },
    editDetailField: {
      type: String,
      default: 'inEditDetail'
    }
  },
  data () {
    return {
      scopeItem: null,
      // leftOffset: 0,
      // scrollLeft: 0,
    }
  },
  created () {
    this.resetScopeItem(true)
  },
  mounted () {
    // this.$nextTick(() => {
    //   const tr = this.$el.closest('tr')
    //   if (tr) {
    //     let offset = 0
    //     const tds = Array.from(tr.children)
    //     for (let i = 0; i < this.dataIndex; i++) {
    //       offset += tds[i]?.offsetWidth || 0
    //     }

    //     this.leftOffset = offset 
    //   }
    //   const gridContent = this.$el.closest('.k-grid-content')
    //   if (gridContent) {
    //     gridContent.addEventListener('scroll', this.syncDetailScroll)
    //   }
    // })
  },
  watch: {
    dataItem: {
      deep: true,
      handler: function (value) {
        this.resetScopeItem(true)
      }
    }
  },
  computed: {
    isSelected: {
      get: function () {
        return getNestedValue(this.selectedField, this.dataItem)
      },
      set: function (value) {
        setNestedValue(this.selectedField, this.dataItem, value)
        setNestedValue(this.selectedField, this.scopeItem, value)
      }
    },
    isInEdit: {
      get: function () {
        return getNestedValue(this.editField, this.dataItem)
      },
      set: function (value) {
        setNestedValue(this.editField, this.dataItem, value)
        setNestedValue(this.editField, this.scopeItem, value)
      }
    },
    isInEditDetail: {
      get: function () {
        return getNestedValue(this.editDetailField, this.dataItem)
      },
      set: function (value) {
        setNestedValue(this.editDetailField, this.dataItem, value)
        setNestedValue(this.editDetailField, this.scopeItem, value)
      }
    },
    isExpanded: {
      get: function () {
        return getNestedValue(this.expandField, this.dataItem)
      },
      set: function (value) {
        setNestedValue(this.expandField, this.dataItem, value)
        setNestedValue(this.expandField, this.scopeItem, value)
      }
    },
    // detailStyle: function () {
    //   return { 
    //     width: `calc(100% - ${this.leftOffset}px)`,
    //     transform: `translateX(${this.scrollLeft}px)`,
    //     right: 0,
    //     position: 'absolute'
    //   }
    // }
  },
  methods: {
    // syncDetailScroll (event) {
    //   this.scrollLeft = event.target.scrollLeft
    // },
    updateDataItem: function (keepEdit = false) {
      const oldDataItem = cloneDeep(this.dataItem)
      const changes = getChanges(this.dataItem, this.scopeItem, [this.selectedField, this.editField, this.expandField])
      merge(this.dataItem, this.scopeItem)
      if (!keepEdit) {
        this.setInEdit(false)
        this.setInEditDetail(false)
      }
      this.$emit('change', { dataItem: this.dataItem, oldDataItem, fields: keys(changes), changes })
    },
    resetScopeItem: function (keepEdit = false) {
      this.scopeItem = cloneDeep(this.dataItem)
      if (!keepEdit) {
        this.setInEdit(false)
        this.setInEditDetail(false)
      }
    },
    setSelected: function (value) {
      this.isSelected = value
    },
    setInEdit: function (value) {
      this.isInEdit = value
    },
    setInEditDetail: function (value) {
      this.isInEditDetail = value
    },
    setExpanded: function (value) {
      this.isExpanded = value
    }
  },
}
</script>
